export function getData(url, success, error) {
    const request = new XMLHttpRequest();
    request.open('GET', url, true);

    request.onload = function () {
        if (this.status >= 200 && this.status < 400) {
            const data = JSON.parse(this.response);
            !!success && success(data);
        } else {
            !!error && error(this.error);
        }
    };

    request.onerror = function () {
        !!error && error();
    };

    request.send();
}
